export default "https://cdn-static.gokick.com/assets/4894ba43e4289cab16e653fbabc6637092de6282/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";